import AddonConfigurationUnit from "./units/addonConfiguration";
import DocumentGenerationUnit from "./units/documentGeneration";
import InitializationUnit from "./units/initialization";
import PhasesConfigurationUnit from "./units/phasesConfiguration";
import ProductSelectionUnit from "./units/productSelection";
export { default as SalesforceWorkflow } from "./salesforce";
export { WorkflowBuilder, WorkflowUnitBuilder } from "./builder";
export { Workflow, WorkflowUnit, makeAction } from "./workflow";
export var WorkflowUnits = {
    InitializationUnit: InitializationUnit,
    ProductSelectionUnit: ProductSelectionUnit,
    DocumentGenerationUnit: DocumentGenerationUnit,
    PhasesConfigurationUnit: PhasesConfigurationUnit,
    AddonConfigurationUnit: AddonConfigurationUnit
};
